import React, { useState } from 'react';
import { Button } from '@fiverr-private/button';
import { getContext } from '@fiverr-private/fiverr_context';
import { I18n } from '@fiverr-private/i18n-react';
import { fetchCustomOrderFormData } from '@fiverr-private/seller_pages_toolbox';
import { bigQuery, EVENT_TYPE, PAGE_NAME } from '../../../monitoring/bigQuery';
import { mixpanel } from '../../../monitoring/mixpanel';
import { useCustomOrderModal, useCustomOrderModalUpdater } from '../../../hooks/useCustomOrderModal';
import { AgencyCreateBriefButton } from '../../AgencyCreateBriefButton';
import { useAiBriefAvailablity } from '../../../hooks/useAiBriefAvailability';
import { ContactButtonPosition } from '../../../monitoring/bigQuery/createContactButtonEventEnrichment';
import { useAgencySellerData } from '../../../hooks/useAgencySellerData';
import { AgencySeller } from '../../../types';

interface CustomOrderButtonProps {
    onModalOpen?: () => void;
    biSource?: string;
    position: ContactButtonPosition;
}

export const CustomOrderButton = ({ onModalOpen, biSource, position }: CustomOrderButtonProps) => {
    const { userId } = getContext();
    const [isLoading, setIsLoading] = useState(false);
    const modalData = useCustomOrderModal();
    const modalDataUpdater = useCustomOrderModalUpdater();
    const { username } = useAgencySellerData(selectSellerSlice);
    const isAiBriefAvailable = useAiBriefAvailablity();

    const onClick = async () => {
        bigQuery.clickEvent(EVENT_TYPE.CLICKED_ON_GET_QUOTE, {
            page: {
                component: {
                    position: biSource,
                },
            },
        });
        mixpanel.event('Services - Request a quote clicked');

        if (!userId) {
            window.openSignUpModal?.({}, { source: PAGE_NAME });
            return;
        }

        if (modalData.data) {
            onModalOpen?.();
            modalDataUpdater({ isOpen: true, data: modalData.data });
            return;
        }

        setIsLoading(true);

        try {
            const { data } = await fetchCustomOrderFormData(username);
            onModalOpen?.();
            modalDataUpdater({ isOpen: true, data });
        } finally {
            setIsLoading(false);
        }
    };

    return isAiBriefAvailable ? (
        <AgencyCreateBriefButton biSource={position} />
    ) : (
        <Button size="lg" disabled={isLoading} loading={isLoading} onClick={onClick}>
            <I18n k="agency_page_perseus.request_a_quote" />
        </Button>
    );
};

const selectSellerSlice = (seller: AgencySeller) => ({
    username: seller.user.name,
    displayName: seller.user.profile.displayName,
    profileImageUrl: seller.user.profileImageUrl,
});
